"use client";

import type { ReactNode } from "react";
import { withToast } from "./toast";

// A <form> whose server action shows a Done/Failed toast on completion.
// Drop-in replacement for `<form action={serverAction}>` in the admin UI.
export function ActionForm({
  action,
  children,
  className,
}: {
  action: (formData: FormData) => unknown | Promise<unknown>;
  children: ReactNode;
  className?: string;
}) {
  return (
    <form action={withToast(action)} className={className}>
      {children}
    </form>
  );
}
